<template>
  <div style="width: 100%;">
    <template v-if="!loading">
      <div class="col-12">
        <b-form-textarea class="notes-input" v-model="notes" />
        <b-button
          size="lg"
          variant="primary"
          :disabled="disableSaveNotesBtn || isSaving"
          class="save-note"
          @click="saveNotes"
        >
          {{ $t('saveNote') }}
          <i v-if="isSaving" class="fa fa-spinner loading-animation" />
        </b-button>
        <a
          href="#"
          @click.stop.prevent="deleteAllNotes"
        >
          {{ $t('deleteAllNotes') }}
        </a>
      </div>
    </template>
    <template v-else>
      <loading customStyle="padding-top: 0;" />
    </template>
  </div>
  
</template>

<script>
  import Loading from './Loading'

  export default {
    name: 'Notes',
    components: {
      'loading': Loading
    },
    data () {
      return {
        loading: false,
        isInputUpdated: false,
        previousNotesInput: '',
        isSaving: false,
        notes: ''
      }
    },
    props: {
      licenseId: {
        type: Number,
        required: true
      },
      AssetID: {
        type: Number,
        required: true
      }
    },
    computed: {
      disableSaveNotesBtn () {
        if (this.notes === '' || this.notes === this.previousNotesInput) return true
        return false
      },
      activationId () {
        return this.$route.params.licenseId || ''
      },
      customerId () {
        return this.$store.getters.person.customerId
      },
      loggedInUserName () {
        return this.$store.getters.authToken.userName || ''
      }
    },
    mounted () {
      this.loading = true
      this.bottle.get(this.UrlBuilder.licenseDetailNotesUrl(
        this.$store.getters.person.customerId,
        this.licenseId
      ))
        .then(({ data }) => {
          this.notes = (data.Notes || []).reduce((acc, cur) => acc + cur.value, '')
          this.previousNotesInput = this.notes
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          this.loggly.log({
            errorMessage: `Failed to fetch notes for ${this.licenseId}`,
            errorObject: error,
            errorStack: error.stack
          })
        })
    },
    methods: {
      saveNotes (isSaving = true) {
        this.isSaving = isSaving
        this.bottle.post(this.UrlBuilder.saveNotesUrl, {
          AssetId: this.AssetID,
          value: this.notes,
          customerID: this.customerId,
          loggedInUser: this.loggedInUserName
        })
          .then(({ data }) => {
            this.isSaving = false
            this.previousNotesInput = this.notes
          })
          .catch((error) => {
            this.isSaving = false
            this.loggly.log({
              errorMessage: `Failed to fetch notes for ${this.activationId}`,
              errorObject: error,
              errorStack: error.stack
            })
          })
      },
      deleteAllNotes () {
        this.notes = ''
        this.saveNotes(false)
      }
    }
  }
</script>

<style lang="scss">
@import '../styles/variables.scss';

.save-note {
  border-radius: 25px;
  margin-right: 20px;
}
a[disabled] {
  color: $disabledGray;
  cursor: not-allowed;
}

.loading-container {
  padding-top: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.loading-animation {
  animation: loading-spin infinite 1s linear;
}
@keyframes loading-spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
</style>


// WEBPACK FOOTER //
// src/components/Notes.vue